import React, {useState} from "react";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import AnimationRevealPage from "../../helpers/AnimationRevealPage";
import tw from "twin.macro";
import FormLabel from "@material-ui/core/FormLabel";
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "react-redux";
import {setValuesAuctionParts} from "../../state/auction/auctionActions";

const Form = tw.div`mb-5 mx-5 mr-3`;

const SubjectiveMeansPartI = ({no, edit, auctionObject}) => {

    const useStyles = makeStyles((theme) => ({
        input: {
            padding: '10px !important',
            width: '100% !important',
        },
        label: {
            marginBottom: '3%',
            fontSize: '1.1em',
            lineHeight: '1.4',
            textAlign: 'left',
            color: 'black',
            width: '100%',
        },
        nameSec: {
            fontFamily: 'Inter !important',
            fontSize: '1.6em !important',
            fontWeight: 'bolder',
            color: '#935bff',
            textAlign: 'center',
            marginBottom: '6% !important',
            borderBottom: '1px solid black',
            padding: '3%'
        },
        radio: {
            marginTop: '3%',
        }
    }));

    const classes = useStyles();

    const [addValue1, setAddValue1] = useState(edit === 'edit' && (auctionObject.ifSubjectiveMeans2 === true && 2));
    const [addValue2, setAddValue2] = useState(edit === 'edit' && (auctionObject.ifSubjectiveMeans1 === true && 2));

    const formAuctionParts = useSelector(state => state.auction.form.auctionItemParts);
    const dispatch = useDispatch();

    const setValueAuctionParts = (e, i) => {
        dispatch(setValuesAuctionParts(e.target.name, e.target.value, i));
        console.log(formAuctionParts);
    }

    const setBooleanValueAuctionParts = (e, i) => {
        dispatch(setValuesAuctionParts(e.target.name, e.target.value === 'true', i));
    }

    const handleChange1 = (e) => {
        if(e.target.value === 'false'){
            setAddValue1(1);
        }else if(e.target.value === 'true'){
            setAddValue1(2);
        }
    }

    const handleChange2 = (e) => {
        if(e.target.value === 'false'){
            setAddValue2(1);
        }else if(e.target.value === 'true'){
            setAddValue2(2);
        }
    }

    let form1;
    let form2;

    if (addValue2 === 2){
        form2 =
            <>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Wykaz wymaganych przedmiotowych środków dowodowych</FormLabel>
                        <TextValidator
                            value={formAuctionParts.meansList}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            defaultValue={edit === 'edit' ? auctionObject.meansList : ''}
                            className={classes.input}
                            type="text"
                            id="outlined-basic-u"
                            label="wykaz wymaganych podmiotowych środków dowodowych"
                            variant="outlined"
                            multiline
                            name="meansList"
                            rows={5}
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Wykaz innych wymaganych oświadczeń lub dokumentów</FormLabel>
                        <TextValidator
                            value={formAuctionParts.otherMeansList}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList) : ''}
                            name="otherMeansList"
                            className={classes.input}
                            type="text"
                            id="outlined-basic-u"
                            label="wykaz innych wymaganych oświadczeń lub dokumentów"
                            variant="outlined"
                            multiline
                            rows={5}
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Wykaz przedmiotowych środków dowodowych podlegających uzupełnieniu</FormLabel>
                        <TextValidator
                            value={formAuctionParts.subjectiveMeansList1}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList1) : ''}
                            name="subjectiveMeansList1"
                            className={classes.input}
                            type="text"
                            id="outlined-basic-u"
                            label="Wykaz przedmiotowych środków dowodowych"
                            variant="outlined"
                            multiline
                            rows={5}
                        />
                    </FormControl>
                </Form>
            </>
    }

    if (addValue1 === 2){
        form1 =
            <>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Potwierdzenie braku podstaw do wykluczenia - wykaz wymaganych podmiotowych środków dowodowych</FormLabel>
                        <TextValidator
                            value={formAuctionParts.subjectiveMeansList2}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList2) : ''}
                            className={classes.input}
                            name="subjectiveMeansList2"
                            type="text"
                            id="outlined-basic-u"
                            label="wykaz wymaganych podmiotowych środków dowodowych"
                            variant="outlined"
                            multiline
                            rows={5}
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Spełnienie warunków udziału w postępowaniu lub kryteriów selekcji - wykaz wymaganych podmiotowych środków dowodowych</FormLabel>
                        <TextValidator
                            value={formAuctionParts.subjectiveMeansList3}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList3) : ''}
                            name="subjectiveMeansList3"
                            className={classes.input}
                            type="text"
                            id="outlined-basic-u"
                            label="wykaz wymaganych podmiotowych środków dowodowych"
                            variant="outlined"
                            multiline
                            rows={5}
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Wykaz wymaganych przedmiotowych środków dowodowych</FormLabel>
                        <TextValidator
                            value={formAuctionParts.subjectiveMeansList4}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList4) : ''}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            name="subjectiveMeansList4"
                            className={classes.input}
                            type="text"
                            id="outlined-basic-u"
                            label="wykaz wymaganych podmiotowych środków dowodowych"
                            variant="outlined"
                            multiline
                            rows={5}
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label}>
                        <FormLabel className={classes.label}>Wykaz innych wymaganych oświadczeń lub dokumentów</FormLabel>
                        <TextValidator
                            className={classes.input}
                            defaultValue={edit === 'edit' ? (auctionObject.subjectiveMeansList5) : ''}
                            value={formAuctionParts.subjectiveMeansList5}
                            onChange={(e) => setValueAuctionParts(e, no)}
                            type="text"
                            id="outlined-basic-u"
                            label="Wykaz innych wymaganych oświadczeń lub dokumentów"
                            variant="outlined"
                            multiline
                            rows={5}
                            name="subjectiveMeansList5"
                        />
                    </FormControl>
                </Form>
                <Form className={classes.label}>
                    <FormControl className={classes.label} value={formAuctionParts[no].ifSubjectiveMeans1.toString()} name="ifSubjectiveMeans1">
                        <RadioGroup name="ifSubjectiveMeans1" defaultValue={edit === 'edit' && auctionObject.ifSubjectiveMeans1.toString()} onChange={(e) => {setBooleanValueAuctionParts(e, no); handleChange2(e);}}>
                            <FormControlLabel value='false' control={<Radio color="primary"/>} label="Zamawiający nie przewiduje uzupełnienia przedmiotowych środków dowodowych po złożeniu oferty zgodnie z art. 107 ust. 2 i 3" />
                            <FormControlLabel value='true' control={<Radio color="primary"/>} label="Zamawiający przewiduje uzupełnienie przedmiotowych środków dowodowych po złożeniu oferty zgodnie z art. 107 ust. 2 i 3" />
                        </RadioGroup>
                    </FormControl>
                </Form>
                {form2}
            </>
    }

    return (
        <>
            <AnimationRevealPage>
                <ValidatorForm>
                    <Form className={classes.label}>
                        <FormControl className={classes.label} value={formAuctionParts[no].ifSubjectiveMeans2.toString()} name="ifSubjectiveMeans2">
                            <RadioGroup name="ifSubjectiveMeans2" defaultValue={edit === 'edit' && auctionObject.ifSubjectiveMeans2.toString()} onChange={(e) => {setBooleanValueAuctionParts(e, no); handleChange1(e);}}>
                                <FormControlLabel value='false' control={<Radio color="primary"/>} label="Zamawiający nie będzie wymagał złożenia podmiotowych środków dochodowych" />
                                <FormControlLabel value='true' control={<Radio color="primary"/>} label="Zamawiający będzie wymagał złożenia podmiotowych środków dochodowych" />
                            </RadioGroup>
                        </FormControl>
                    </Form>
                    {form1}
                </ValidatorForm>
            </AnimationRevealPage>
        </>
    )
}


export default SubjectiveMeansPartI;